import api from './api';
import { API_ENDPOINTS, USE_MOCK_DATA, TOKEN_KEY, USER_KEY } from '../constants/config';

class AuthService {
  async login(username, password) {
    if (USE_MOCK_DATA) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const mockUser = {
            id: 1,
            name: 'Admin User',
            email: username,
            role: 'ADMIN'
          };
          const mockToken = 'mock_jwt_access_token';
          localStorage.setItem(TOKEN_KEY, mockToken);
          localStorage.setItem(USER_KEY, JSON.stringify(mockUser));
          resolve({ success: true, data: mockUser });
        }, 500);
      });
    }

    try {
      // V2 endpoint accepts JSON or form-data
      const response = await api.post(API_ENDPOINTS.LOGIN, {
        username: username.trim(),
        password: password
      });
      
      const { access_token, user } = response.data;
      
      if (access_token) {
        localStorage.setItem(TOKEN_KEY, access_token);
      }
      
      if (user) {
        localStorage.setItem(USER_KEY, JSON.stringify(user));
      }
      
      return { success: true, data: user || response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.detail || 'Invalid credentials' 
      };
    }
  }

  async logout() {
    if (!USE_MOCK_DATA) {
      try {
        await api.post(API_ENDPOINTS.LOGOUT);
      } catch (error) {
        console.error('Logout error:', error);
      }
    }
    // Clear tokens and cached user info
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  }

  // Verifies the session by hitting the backend with Authorization: Bearer <token>
  async getMe() {
    if (USE_MOCK_DATA) {
      const userData = localStorage.getItem(USER_KEY);
      return userData ? { success: true, data: JSON.parse(userData) } : { success: false };
    }

    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      localStorage.removeItem(USER_KEY);
      return { success: false, error: 'No active session' };
    }

    try {
      const response = await api.get(API_ENDPOINTS.ME);
      const user = response.data;
      // Sync cache
      localStorage.setItem(USER_KEY, JSON.stringify(user));
      return { success: true, data: user };
    } catch (error) {
      // If /me fails (401), the token is invalid or expired
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
      return { success: false, error: error.response?.data?.detail || 'Session expired' };
    }
  }

  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  }

  isAuthenticated() {
    return !!localStorage.getItem(TOKEN_KEY);
  }

  getCurrentUser() {
    const userData = localStorage.getItem(USER_KEY);
    return userData ? JSON.parse(userData) : null;
  }
}

export default new AuthService();